import styles from "./../styles.module.css";

export function IconeCursor() {
  return (
    <svg
      className={`${styles.cardSinal} ${styles.iconeCursor}`}
      width="153"
      height="267"
      viewBox="0 0 153 267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_511_792" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M116.778 157.395L10.2836 42.5639L2.21088 198.968L37.9678 185.993L67.1535 266.424L110.989 250.517L81.8038 170.086L116.778 157.395Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.778 157.395L10.2836 42.5639L2.21088 198.968L37.9678 185.993L67.1535 266.424L110.989 250.517L81.8038 170.086L116.778 157.395Z"
        fill="#73D676"
      />
      <path
        d="M10.2836 42.5639L13.2164 39.844L6.77701 32.9004L6.28888 42.3578L10.2836 42.5639ZM116.778 157.395L118.142 161.155L123.812 159.098L119.711 154.675L116.778 157.395ZM2.21088 198.968L-1.7838 198.762L-2.09471 204.785L3.57529 202.728L2.21088 198.968ZM37.9678 185.993L41.7279 184.628L40.3635 180.868L36.6034 182.233L37.9678 185.993ZM67.1535 266.424L63.3934 267.788L64.7578 271.548L68.5179 270.184L67.1535 266.424ZM110.989 250.517L112.354 254.277L116.114 252.913L114.75 249.153L110.989 250.517ZM81.8038 170.086L80.4394 166.326L76.6793 167.691L78.0437 171.451L81.8038 170.086ZM7.35067 45.2839L113.845 160.115L119.711 154.675L13.2164 39.844L7.35067 45.2839ZM6.20556 199.174L14.2782 42.7701L6.28888 42.3578L-1.7838 198.762L6.20556 199.174ZM36.6034 182.233L0.846471 195.208L3.57529 202.728L39.3322 189.753L36.6034 182.233ZM70.9136 265.059L41.7279 184.628L34.2077 187.357L63.3934 267.788L70.9136 265.059ZM109.625 246.757L65.7891 262.664L68.5179 270.184L112.354 254.277L109.625 246.757ZM78.0437 171.451L107.229 251.882L114.75 249.153L85.5639 168.722L78.0437 171.451ZM115.414 153.635L80.4394 166.326L83.1682 173.846L118.142 161.155L115.414 153.635Z"
        fill="black"
        mask="url(#path-1-inside-1_511_792)"
      />
      <mask id="path-3-inside-2_511_792" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M134.796 136.007L28.3016 21.1751L20.229 177.579L55.9859 164.604L85.1715 245.035L129.008 229.129L99.8218 148.697L134.796 136.007Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.796 136.007L28.3016 21.1751L20.229 177.579L55.9859 164.604L85.1715 245.035L129.008 229.129L99.8218 148.697L134.796 136.007Z"
        fill="#73D676"
      />
      <path
        d="M28.3016 21.1751L31.2345 18.4552L24.7951 11.5116L24.307 20.969L28.3016 21.1751ZM134.796 136.007L136.16 139.767L141.831 137.709L137.729 133.287L134.796 136.007ZM20.229 177.579L16.2343 177.373L15.9234 183.396L21.5934 181.339L20.229 177.579ZM55.9859 164.604L59.746 163.24L58.3815 159.479L54.6214 160.844L55.9859 164.604ZM85.1715 245.035L81.4114 246.4L82.7758 250.16L86.5359 248.795L85.1715 245.035ZM129.008 229.129L130.372 232.889L134.132 231.524L132.768 227.764L129.008 229.129ZM99.8218 148.697L98.4574 144.937L94.6973 146.302L96.0617 150.062L99.8218 148.697ZM25.3687 23.8951L131.863 138.726L137.729 133.287L31.2345 18.4552L25.3687 23.8951ZM24.2236 177.785L32.2963 21.3813L24.307 20.969L16.2343 177.373L24.2236 177.785ZM54.6214 160.844L18.8645 173.819L21.5934 181.339L57.3503 168.364L54.6214 160.844ZM88.9316 243.671L59.746 163.24L52.2257 165.968L81.4114 246.4L88.9316 243.671ZM127.643 225.369L83.8071 241.275L86.5359 248.795L130.372 232.889L127.643 225.369ZM96.0617 150.062L125.247 230.493L132.768 227.764L103.582 147.333L96.0617 150.062ZM133.432 132.246L98.4574 144.937L101.186 152.458L136.16 139.767L133.432 132.246Z"
        fill="black"
        mask="url(#path-3-inside-2_511_792)"
      />
      <mask id="path-5-inside-3_511_792" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M152.814 114.618L46.3198 -0.213774L38.2472 156.19L74.004 143.215L103.19 223.646L147.026 207.74L117.84 127.309L152.814 114.618Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M152.814 114.618L46.3198 -0.213774L38.2472 156.19L74.004 143.215L103.19 223.646L147.026 207.74L117.84 127.309L152.814 114.618Z"
        fill="white"
      />
      <path
        d="M46.3198 -0.213774L49.2527 -2.93373L42.8133 -9.87728L42.3251 -0.419957L46.3198 -0.213774ZM152.814 114.618L154.179 118.378L159.849 116.32L155.747 111.898L152.814 114.618ZM38.2472 156.19L34.2525 155.984L33.9416 162.008L39.6116 159.95L38.2472 156.19ZM74.004 143.215L77.7641 141.851L76.3997 138.091L72.6396 139.455L74.004 143.215ZM103.19 223.646L99.4295 225.011L100.794 228.771L104.554 227.406L103.19 223.646ZM147.026 207.74L148.39 211.5L152.15 210.135L150.786 206.375L147.026 207.74ZM117.84 127.309L116.476 123.548L112.715 124.913L114.08 128.673L117.84 127.309ZM43.3869 2.50618L149.881 117.338L155.747 111.898L49.2527 -2.93373L43.3869 2.50618ZM42.2418 156.396L50.3145 -0.00759108L42.3251 -0.419957L34.2525 155.984L42.2418 156.396ZM72.6396 139.455L36.8827 152.43L39.6116 159.95L75.3684 146.975L72.6396 139.455ZM106.95 222.282L77.7641 141.851L70.2439 144.58L99.4295 225.011L106.95 222.282ZM145.661 203.98L101.825 219.886L104.554 227.406L148.39 211.5L145.661 203.98ZM114.08 128.673L143.265 209.104L150.786 206.375L121.6 125.944L114.08 128.673ZM151.45 110.857L116.476 123.548L119.204 131.069L154.179 118.378L151.45 110.857Z"
        fill="black"
        mask="url(#path-5-inside-3_511_792)"
      />
    </svg>
  );
}
